<template>
  <v-app>
    <template v-if="$route.name !== 'login'">
      <v-navigation-drawer app :mobileBreakPoint="960" v-model="drawer">
        <v-btn
          active-class
          :to="{ name: 'home' }"
          flat
          block
          style="min-height:200px"
        >
          <v-img
            contain
            max-height="200"
            :src="require('./assets/img/logo.png')"
          />
        </v-btn>

        <v-divider />

        <v-list dense class="pt-0">
          <v-list-tile :to="{ name: 'user-management' }">
            <v-list-tile-action>
              <v-icon v-text="fa('user')"></v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>User management</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile :to="{ name: 'app-configs' }">
            <v-list-tile-action>
              <v-icon v-text="fa('cogs')"></v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>App configs</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile :to="{ name: 'themes' }">
            <v-list-tile-action>
              <v-icon v-text="fa('palette')"></v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>Themes</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-group
            v-for="item in items"
            :key="item.title"
            v-model="item.active"
            :prepend-icon="fa(item.action)"
            no-action
          >
            <template v-slot:activator>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>

            <v-list-tile
              v-for="subItem in item.items"
              :key="subItem.title"
              :to="subItem.to"
            >
              <v-list-tile-content>
                <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
              </v-list-tile-content>

              <!-- <v-list-tile-action>
                <v-icon v-text="fa(subItem.action)"></v-icon>
              </v-list-tile-action> -->
            </v-list-tile>
          </v-list-group>
        </v-list>
      </v-navigation-drawer>

      <v-toolbar app>
        <v-toolbar-side-icon @click.stop="drawer = !drawer" />
        <v-toolbar-title class="headline text-uppercase">
          <span v-text="pageTitle"></span>
        </v-toolbar-title>
        <v-spacer />

        <strong v-if="eventHub.user" v-text="eventHub.user.email" />
        <!-- <v-btn flat>
          <span class="mr-2">Help</span>
        </v-btn> -->
        <v-btn flat @click="logout">
          <span class="mr-2">Logout</span>
        </v-btn>
      </v-toolbar>
    </template>

    <v-content>
      <v-container fluid fill-height>
        <router-view />
        <v-snackbar v-model="message.snackbar" :timeout="15000" top>
          {{ message.message }}
          <v-btn :color="message.color" flat @click="message.snackbar = false"
            >Close</v-btn
          >
        </v-snackbar>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { db, auth } from "./plugins/firebase";
import { appConfig, eventHub } from "./config/constants";

export default {
  name: "App",
  data() {
    return {
      eventHub,
      drawer: this.$vuetify.breakpoint.mdAndUp,
      sideMenus: [],
      topMenus: [],
      bottomMenus: [],
      cardPages: [],
      listPages: [],
      contentPages: [],
      slidePages: [],
      appConfig: null,
      message: {
        snackbar: false,
        message: null,
        color: null
      }
    };
  },
  created() {
    eventHub.user = auth.currentUser;
    eventHub.$on("message", (color, message) => {
      this.message = {
        snackbar: true,
        message: color === "green" ? "Success" : message,
        color
      };
    });
  },
  firestore: {
    sideMenus: db.collection("sideMenus"),
    topMenus: db.collection("topMenus"),
    bottomMenus: db.collection("bottomMenus"),
    cardPages: db.collection("cardPages"),
    listPages: db.collection("listPages"),
    contentPages: db.collection("contentPages"),
    slidePages: db.collection("slidePages"),
    appConfig: db.collection("appConfigs").doc(appConfig)
  },
  methods: {
    async logout() {
      try {
        await this.$auth.signOut();
        this.$router.push({
          name: "login",
          query: { nextUrl: this.$route.fullPath }
        });
      } catch (error) {
        eventHub.$emit("message", "red", error.message);
      }
    }
  },
  computed: {
    pageTitle() {
      const { name, params, matched } = this.$route;
      const pagesTitles = {
        home: "Home",
        "user-management": "User management",
        "app-configs": "App configs",
        themes: "Themes",
        "card-pages": "Card pages",
        "list-pages": "List pages",
        "content-pages": "Content pages",
        "side-menus": "Side menus",
        "bottom-menus": "Bottom menus",
        "slide-pages": "Slide pages"
      };
      let pageTitle = pagesTitles[name];
      if (matched.length > 1) {
        pageTitle = pagesTitles[matched[0].name];
        if (params.language) {
          pageTitle += " " + params.language;
        }
      }
      return pageTitle;
    },
    items() {
      const path = this.$route.path;
      return [
        {
          title: "Side menus",
          active: path.indexOf("/side-menus") === 0,
          action: "ellipsis-v",
          items: this.sideMenus
            .reduce((languages, sideMenu) => {
              if (!~languages.indexOf(sideMenu.language)) {
                languages.push(sideMenu.language);
              }
              return languages;
            }, [])
            .map(language => ({
              title: language,
              to: {
                name: "side-menus",
                params: {
                  language
                }
              },
              action: null
            }))
        },
        {
          title: "Top menus",
          active: path.indexOf("/top-menus") === 0,
          action: "ellipsis-v",
          items: this.topMenus
            .reduce((languages, topMenu) => {
              if (!~languages.indexOf(topMenu.language)) {
                languages.push(topMenu.language);
              }
              return languages;
            }, [])
            .map(language => ({
              title: language,
              to: {
                name: "top-menus",
                params: {
                  language
                }
              },
              action: null
            }))
        },
        {
          title: "Bottom menus",
          active: path.indexOf("/bottom-menus") === 0,
          action: "ellipsis-v",
          items: this.bottomMenus
            .reduce((languages, bottomMenu) => {
              if (!~languages.indexOf(bottomMenu.language)) {
                languages.push(bottomMenu.language);
              }
              return languages;
            }, [])
            .map(language => ({
              title: language,
              to: {
                name: "bottom-menus",
                params: {
                  language
                }
              },
              action: null
            }))
        },
        {
          title: "Card pages",
          active: path.indexOf("/card-pages") === 0,
          action: "pager",
          items: this.cardPages
            .reduce((languages, cardPage) => {
              if (!~languages.indexOf(cardPage.language)) {
                languages.push(cardPage.language);
              }
              return languages;
            }, [])
            .map(language => ({
              title: language,
              to: {
                name: "card-pages-list",
                params: {
                  language
                }
              },
              action: null
            }))
        },
        {
          title: "List pages",
          active: path.indexOf("/list-pages") === 0,
          action: "list",
          items: this.listPages
            .reduce((languages, listPage) => {
              if (!~languages.indexOf(listPage.language)) {
                languages.push(listPage.language);
              }
              return languages;
            }, [])
            .map(language => ({
              title: language,
              to: {
                name: "list-pages-list",
                params: {
                  language
                }
              },
              action: null
            }))
        },
        {
          title: "Content pages",
          active: path.indexOf("/content-pages") === 0,
          action: "newspaper",
          items: this.contentPages
            .reduce((languages, contentPage) => {
              if (!~languages.indexOf(contentPage.language)) {
                languages.push(contentPage.language);
              }
              return languages;
            }, [])
            .map(language => ({
              title: language,
              to: {
                name: "content-pages-list",
                params: {
                  language
                }
              },
              action: null
            }))
        },
        {
          title: "Slide pages",
          active: path.indexOf("/slide-pages") === 0,
          action: "window-restore",
          items: this.slidePages
            .reduce((languages, slidePage) => {
              if (!~languages.indexOf(slidePage.language)) {
                languages.push(slidePage.language);
              }
              return languages;
            }, [])
            .map(language => ({
              title: language,
              to: {
                name: "slide-pages",
                params: {
                  language
                }
              },
              action: null
            }))
        },
        {
          title: "Notifications",
          active: path.indexOf("/notifications") === 0,
          action: "bell",
          items:
            this.appConfig &&
            Object.keys(this.appConfig.languages).map(language => ({
              title: language,
              to: {
                name: "notifications",
                params: {
                  language
                }
              },
              action: null
            }))
        }
      ];
    }
  }
};
</script>
